import React from 'react'
import HomeC from '../components/home/HomeC'

const Home = () => {
  return (
    <div>
        <HomeC/>
    </div>
  )
}

export default Home